<template>
    <div>
        <!-- 转仓申请 -->
        <el-dialog title="新增转仓申请单" :visible.sync="addApplyVisible" width="1000px" :close-on-click-modal="false" center>
            <div style="min-height:400px;">

                <!-- 第一步 -->

                <!-- <div style="padding:20px 20px;border:1px solid #ddd;"> -->
                    <!-- 商品搜索条件 -->
                    <!-- <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="商品名称">
                            <el-input v-model="productQuery.commodityName" placeholder="请输入商品名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="商品编码">
                            <el-input v-model="productQuery.spuCode" placeholder="请输入商品编码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="商品类目" v-if="productQuery.type==2">
                            <el-cascader v-model="productQuery.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" size="mini"></el-cascader>
                        </el-form-item>
                        <el-form-item label="商品类型">
                            <el-select v-model="productQuery.type" placeholder="请选择商品类型" clearable>
                                <el-option label="套餐" :value="1"></el-option>
                                <el-option label="单品" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="productSearch">搜索</el-button>
                        </el-form-item>
                    </el-form> -->

                    <!-- 商品列表 -->
                    <!-- <el-table :data="addProductQueryShow" border class="table" max-height="320" ref="multipleTable">
                        <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
                        <el-table-column prop="spuCode" label="商品编码"></el-table-column>
                        <el-table-column prop="categoryName" label="商品类目"></el-table-column>
                        <el-table-column prop="brandName" label="品牌"></el-table-column>
                        <el-table-column prop="salesType" label="销售类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.salesType == 1">租借</span>
                                <span v-if="scope.row.salesType == 2">售卖</span>
                                <span v-if="scope.row.salesType == 3">租借和售卖</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="satus" label="商品状态">
                            <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                        </el-table-column>
                        <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>

                        <el-table-column prop="name" label="操作" width="55">
                            <template slot-scope="scope">
                                <el-button @click="addConfirm(scope.row)" type="text" size="small">添加</el-button>
                            </template>
                        </el-table-column>
                    </el-table> -->

                    <!-- 已选商品 -->
                    <div style="padding:0 10px 10px;border:1px solid #ddd;margin-top:20px;">
                        <el-form style="margin-top:10px;" :inline="true" class="demo-form-inline">

                            <el-form-item label="申请转入仓">
                                <el-select v-model="skuSelectForm.inHouseId" clearable placeholder="选择库仓" disabled filterable>
                                    <template v-for="(item,index) in applyHouseList">
                                        <el-option :key="index" :label="item.houseName" :value="item.id"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="转出仓">
                                <el-select v-model="skuSelectForm.outHouseId" clearable placeholder="选择库仓" filterable>
                                    <el-option v-for="(item,index) in applyHouseList" :key="index" :label="item.houseName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出库量">
                                <el-select v-model="skuSelectForm.inOutAmount" clearable placeholder="请选择" filterable>
                                    <el-option label="部分" value="1"></el-option>
                                    <el-option label="全部" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出库方式">
                                <el-select v-model="skuSelectForm.outMode" clearable placeholder="请选择" filterable>
                                    <el-option label="邮寄" value="1"></el-option>
                                    <el-option label="货拉拉" value="2"></el-option>
                                    <el-option label="现场领取" value="3"></el-option>
                                </el-select>
                            </el-form-item>

                        </el-form>
                        <!-- 已选单品 -->
                        <p style="margin:20px 0; border-left:4px solid #409EFF;">已选商品：</p>
                        <el-table :data="skuSelectForm.chooseList" border class="table" max-height="320" ref="multipleTable">
                            <!-- <el-table-column prop="package" label="商品类型" width="100" fixed="left">
                                <template slot-scope="scope"> -->
                                     <!-- <span v-if="scope.row.package==1" style="color:red;">套餐-{{scope.row.spu.commodityName}}</span>
                                    <span v-if="scope.row.package==2" style="color:blue;">单品</span> -->
                                    <!-- <span v-if="scope.row.skuType==1" style="color:red;">套餐-{{scope.row.spu.commodityName}}</span>
                                    <span v-if="scope.row.skuType==2" style="color:blue;">单品</span> -->
                                <!-- </template>
                            </el-table-column> -->
                            <el-table-column prop="commodityName" label="商品名称"></el-table-column>
                            <el-table-column prop="skuSpec" label="规格">
                                
                                <template slot-scope="scope">
                                    <span>{{scope.row.skuSpec[0]}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量">
                                <template slot-scope="scope">
                                    <el-input type="number" v-model.trim="scope.row.applyNumber"> </el-input>
                                </template>
                            </el-table-column>
                             <el-table-column label="SN码">
                                <template slot-scope="scope">
                                   <!-- {{scope.row.snList}}  @visible-change="chooseSN(scope.row,scope.$index)"   filterable multiple -->
                                   <el-select v-if="scope.row.salesType==1||scope.row.salesType==3" 
                                    @visible-change="chooseSN(scope.row,scope.$index)" @change="selectSN(scope.row,scope.$index)"
                                      filterable multiple  v-model="scope.row.chooseSNList"  placeholder="请选择SN码" > 
                                            <el-option  v-for="(item,index) in scope.row.SNList"   :key="index" :label="item" :value="item"></el-option> 
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                                  
                                <template slot-scope="scope">
                                    <!-- <el-button  type="success"  v-if="scope.row.salesType==1||scope.row.salesType==3" size="small">选择SN码</el-button> -->
                                    <el-button @click="delRow(scope.$index)" type="text" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 已选套餐 -->
                        <!-- <p style="margin:20px 0; border-left:4px solid #409EFF;">已选套餐：</p> -->

                    </div>
                </div>
            <!-- </div> -->

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <el-button type="primary" @click="confSubmit">提交</el-button>
            </span>
        </el-dialog>

        <!-- 规格选择 -->
        <el-dialog title="商品规格" :visible.sync="skuSelectVisable" width="600px" :close-on-click-modal="false" center>

            <p style="margin:0 20px 20px;">请选择商品规格</p>
            <el-form ref="skuSelectForm" label-width="140px" :model="skuSelectForm" size="medium" v-for="(spu, index) in skuSelectForm.spuList" :key="index">
                <el-row>
                    <el-col :span="3" :offset="2" style="padding-top:6px;">
                        {{spu.goodsName}}
                    </el-col>

                    <el-col :span="6">
                    </el-col>

                    <el-form-item :label="'选择商品规格'" :prop="'skuId'" :rules="{
      required: true, message: '规格不能为空', trigger: 'blur'
    }">
                        <el-select v-model="spu.skuId" placeholder="请选择规格" clearable size="mini">
                            <el-option v-for="item in ( spu.skuList)" :key="item.id" :label="item.propertyValue" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="skuSelectVisable=false">取消</el-button>
                <el-button @click="confSku" type="primary">确定</el-button>
            </span>

        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "../css/index.css";

let vm;
export default {
    filters: {
        statusFilter(value) {
            const rs = vm.statusList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
    data() {
        return {
            tempRow: {},
            addApplyVisible: false, //主弹窗显示
            skuSelectVisable: false, //选sku规格
            applyHouseList: [], //当前人拥有的仓库
            categoryList: [], //类目list
            addProductQueryShow: [], //查询spu商品
            productQuery: {
                commodityName: "",
                spuCode: "",
                categoryId: "",
                type: 2,
            },
            skuSelectForm: {
                // houseId: "",
                inHouseId: null,
                outHouseId: null,
                inOutAmount: null,
                outMode: null,
                chooseList: [], //是选择的sku
                spuList: [
                    {
                        skuId: "",
                        curr: {},
                        goodsName: "",
                        skuList: [],
                    },
                ],
            },
            statusList: [
                // {
                //     id: 1,
                //     text: "编辑中",
                // },
                {
                    id: 1,
                    text: "待审核",
                },
                {
                    id: 2,
                    text: "待上架",
                },
                {
                    id: 3,
                    text: "审核不通过",
                },
                {
                    id: 4,
                    text: "上架中",
                },
                {
                    id: 5,
                    text: "已下架",
                },
            ],
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        selectSN(row,index){
            this.$set(this.skuSelectForm.chooseList, index, this.skuSelectForm.chooseList[index]);
        },
        chooseSN(row,index){
            if(this.skuSelectForm.outHouseId==null||this.skuSelectForm.outHouseId==''){
                 this.$message.error("请先选择转出仓");
                return;
            }

            if(this.skuSelectForm.chooseList[index].SNList&&this.skuSelectForm.chooseList[index].SNList.length>0){
                return;
            }
           
            wmsApi.$axiosGetAvaiableSnCode({skuId:row.skuId,houseId:this.skuSelectForm.outHouseId}).then(res=>{
              
                this.skuSelectForm.chooseList[index].SNList=res.data.data;
                this.$set(this.skuSelectForm.chooseList, index, this.skuSelectForm.chooseList[index]);
                 
            })
        },
        showDetail(row){
            this.getAllHouse();
              wmsApi
                .$axiosWmsPurchaseGoodsApplicationDetailo({goodsApplicationId:row.id})
                .then((res) => {
                    console.log(row);
                    this.tempRow = row;
                    this.addApplyVisible = true;
                    this.skuSelectForm.inHouseId = row.houseId;
                    this.skuSelectForm.chooseList = res.data.data; 
                     this.skuSelectForm.chooseList.forEach(dd=>{
                        // dd.chooseSNList=[];
                        // dd.SNList=[];
                     })
                })

        },
        addApply(row) {
            console.log(row);
            this.tempRow = row;
            this.addApplyVisible = true;
            this.skuSelectForm.inHouseId = row.houseId;
            this.skuSelectForm.chooseList = [];

            this.getAllHouse();
            this.getCateGoryTree();

            this.productQuery = {
                commodityName: "",
                spuCode: "",
                brandName: "",
                categoryId: "",
                type: 2,
            };
            this.productSearch();
        },
        getCateGoryTree() {
            wmsApi
                .$axiosCategoryTree({})
                .then((res) => {
                    this.categoryList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getAllHouse() {
            wmsApi
                .$axiosgetAllHouse({ sysUserId: globalData.userInfo.id })
                .then((res) => {
                    this.applyHouseList = res.data.data;

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        productSearch() {
            let temp = {
                page: 1,
                size: 1000,
                type: this.productQuery.type,
                status: 4,
                commodityName: this.productQuery.commodityName,
                spuCode: this.productQuery.spuCode,
            };
            if (this.productQuery.type == 2) {
                temp.categoryId =
                    this.productQuery.categoryId.length >= 3
                        ? this.productQuery.categoryId[2]
                        : "";
            }
            wmsApi
                .$axiosCommodityList(temp)
                .then((res) => {
                    this.addProductQueryShow = res.data.data.list;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addConfirm(row) {
            console.log(row);
            this.skuSelectVisable = true;

            if (row.type == 1) {
                //套餐
                this.skuSelectForm.spuList = [];
                row.childCommoditys.childDetail.forEach((e) => {
                    let dataArr = {
                        skuId: "",
                        curr: row,
                        goodsName: e.spuInfo.commodityName,
                        skuList: e.childSpuDetail,
                    };
                    this.skuSelectForm.spuList.push(dataArr);
                });
            } else {
                //单品
                this.skuSelectForm.spuList = [];
                let dataArr = {
                    skuId: "",
                    curr: row,
                    goodsName: row.commodityName,
                    skuList: row.childCommoditys.childDetail,
                };
                this.skuSelectForm.spuList.push(dataArr);
            }
        },
        confSku() {
            console.log("选择了", this.skuSelectForm.spuList);
            // this.tempArrayList

            let temparr = [];
            this.skuSelectForm.spuList.forEach((e) => {
                e.skuList.forEach((sk) => {
                    if (e.skuId == sk.id) {
                        sk.package = e.curr.type; //标识1套餐，2单品
                        sk.spu = e.curr;
                        // sk.applyNumber=0;//要提交的
                        sk.skuId = sk.id; //要提交的
                        temparr.push(sk);
                    }
                });
            });
            this.skuSelectForm.chooseList =
                this.skuSelectForm.chooseList.concat(temparr);
            console.log("总共选择了", this.skuSelectForm);
            this.skuSelectVisable = false;
        },
        delRow(index) {
            this.skuSelectForm.chooseList.splice(index, 1);
        },
        checkFormData() {
            if (this.skuSelectForm.chooseList.length == 0) {
                this.$message.error("请添加商品");
                return false;
            }
            for (let i = 0; i < this.skuSelectForm.chooseList.length; i++) {
                if (
                    !this.skuSelectForm.chooseList[i].applyNumber ||
                    this.skuSelectForm.chooseList[i].applyNumber <= 0
                ) {
                    this.$message.error("商品数量不能小于0");
                    return false;
                }
            }
            if (
                this.skuSelectForm.outHouseId == ''||
                this.skuSelectForm.outHouseId == null
            ) {
                this.$message.error("请选择仓库");
                return false;
            }
            if (this.skuSelectForm.inOutAmount == null||this.skuSelectForm.inOutAmount =='') {
                this.$message.error("请选择出库量");
                return false;
            }
            if (this.skuSelectForm.outMode == null||this.skuSelectForm.outMode == '') {
                this.$message.error("请选择出库方式");
                return false;
            }
            return true;
        },
        confSubmit() {
            if (!this.checkFormData()) {
                return;
            }

            
            let reqdata = {
                createUserId: globalData.userInfo.id,
                createUserName: globalData.userInfo.userName,
                goodsList: [
                    // {
                    //     codeSn: "",
                    //     costPrice: 0,
                    //     createTime: "",
                    //     houseId: 0,
                    //     inOrOut: 0,
                    //     numbers: 0,
                    //     skuCode: "",
                    //     skuName: "",
                    // },
                ],
                inHouseId: this.skuSelectForm.inHouseId,
                outHouseId: this.skuSelectForm.outHouseId,
                inOutAmount: this.skuSelectForm.inOutAmount,
                operType: 3, //1出库，2入库，3转仓
                // orderAmount: 0,
                outMode: this.skuSelectForm.outMode,
                // reason: "",
                relationNo: this.tempRow.applyCode,
                relationType: 3, //业务类型1采购单入库单，2服务购买单，3转仓单，4盘库单，5租赁归还单
                // remark: "",
                status: 1, //1待处理，2处理中，3已完成，4取消拒绝
            };
            let that=this;
            let boo=true;
            that.skuSelectForm.chooseList.forEach((e) => {
                if((e.salesType==1||e.salesType==3)&& e.chooseSNList.length==0){
                    this.$message.error("租赁商品必须选择SN码才能转仓");
                    boo=false;
                    return;
                }
                if((e.salesType==1||e.salesType==3)&& e.applyNumber>0&&e.applyNumber!=e.chooseSNList.length){
                    this.$message.error("所选数量和SN码数量不一致");
                    boo=false;
                    return;
                }

                if(e.salesType==1||e.salesType==3){
                    //租赁类商品，转仓SN数量要转为1
                    e.chooseSNList.forEach(ssnn=>{
                           //转出，转入2组
                        reqdata.goodsList.push({
                            codeSn: ssnn,
                            // costPrice: 0,
                            // createTime: "",
                            houseId: that.skuSelectForm.inHouseId,
                            inOrOut: 1,//1入库，2出库
                            numbers: 1,
                            skuCode: e.skuCode,
                            skuName: e.commodityName,//+e.propertyValue
                        });
                        reqdata.goodsList.push({
                            codeSn: ssnn,
                            // costPrice: 0,
                            // createTime: "",
                            houseId: that.skuSelectForm.outHouseId,
                            inOrOut: 2,//1入库，2出库
                            numbers: 1,
                            skuCode: e.skuCode,
                            skuName: e.commodityName,//e.propertyValue
                        });
                    })
                    

                }else{  
                        //转出，转入2组
                        reqdata.goodsList.push({
                            // codeSn: "",
                            // costPrice: 0,
                            // createTime: "",
                            houseId: that.skuSelectForm.inHouseId,
                            inOrOut: 1,//1入库，2出库
                            numbers: e.applyNumber,
                            skuCode: e.skuCode,
                            skuName: e.commodityName,//+e.propertyValue
                        });
                        reqdata.goodsList.push({
                            // codeSn: "",
                            // costPrice: 0,
                            // createTime: "",
                            houseId: that.skuSelectForm.outHouseId,
                            inOrOut: 2,//1入库，2出库
                            numbers: e.applyNumber,
                            skuCode: e.skuCode,
                            skuName: e.commodityName,//e.propertyValue
                        });

                }
            });

            if(!boo){
                return;
            }

            //提交
             wmsApi
                .$axioswmsStockOrdertransferStock(reqdata)
                .then((res) => {
                  if (res.data.errno == 0) {
                            this.$message.success("提交成功");
                            this.addApplyVisible = false;
                            // this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                })
                .catch((err) => {
                    console.log(err);
                });
            
        },
    },
};
</script>
<style >
</style>